import { Layout, Table } from 'antd';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { User } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';
import { diff } from 'just-diff';

export function EntityChangeLog(props: { entityName: string; recordId?: string | number }) {
  const { Content } = Layout;

  const [loading, setLoading] = useState(false);
  const [changeLogs, setChangeLogs] = useState<any[]>();

  const loadData = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`audits/filtered?entityName=${props.entityName}&recordId=${props.recordId}`)
      .then(response => {
        setChangeLogs(response.data);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, [props.entityName, props.recordId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const tableColumns = [
    {
      title: 'Kayıt ID',
      dataIndex: 'recordId',
      key: 'recordId',
    },
    {
      title: 'Değişim zamanı',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string) => moment(createdAt).format('DD.MM.yyyy HH:mm:ss'),
    },
    {
      title: 'Değiştiren',
      dataIndex: 'createdBy',
      key: 'createdBy',
      render: (createdBy: User) => createdBy.fullNameId,
    },
    {
      title: 'Eski değer',
      dataIndex: 'valueBefore',
      key: 'valueBefore',
      render: (valueBefore: string, log: any) => {
        const diffs = diff(JSON.parse(log.valueAfter), JSON.parse(valueBefore))
          .map(d => d.path.join('.') + ': ' + d.value)
          .sort((a, b) => (a < b ? -1 : 1));

        return (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {diffs.map(d => (
              <li key={d}>{d}</li>
            ))}
          </ul>
        );
      },
    },
    {
      title: 'Yeni değer',
      dataIndex: 'valueAfter',
      key: 'valueAfter',
      render: (valueAfter: string, log: any) => {
        const diffs = diff(JSON.parse(log.valueBefore), JSON.parse(valueAfter))
          .map(d => d.path.join('.') + ': ' + d.value)
          .sort((a, b) => (a < b ? -1 : 1));

        return (
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {diffs.map(d => (
              <li key={d}>{d}</li>
            ))}
          </ul>
        );
      },
    },
  ];

  return (
    <Content>
      <Table columns={tableColumns} dataSource={changeLogs} loading={loading} pagination={false} />
    </Content>
  );
}
